import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        contactBoxTechnicalFeature: {
          module: () => import('./contact-box-navigation.module').then((m) => m.ContactBoxNavigationModule)
        },
      }
    })
  ]
})
export class ContactBoxNavigationFeatureModule {}
